import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import InboxTransitionBase from './InboxTransitionBase';
import { getFirstName } from '../../util/user';

const InboxTransitionReviewByCustomerLateCancel = ({ transition, user, ownRole, buttons }) => {
  const isOwnTransition = transition.by === ownRole;
  const displayName = getFirstName(get(user, 'attributes.profile.displayName', ''));

  return (
    <InboxTransitionBase
      header={
        isOwnTransition ? (
          <FormattedMessage
            id="BookingStatus.transitionReviewByCustomerLateCancel"
            values={{ displayName }}
          />
        ) : (
          <FormattedMessage
            id="BookingStatus.saleReviewByCustomerLateCancel"
            values={{ displayName }}
          />
        )
      }
      date={transition.createdAt}
      direction="left"
      buttons={buttons}
    />
  );
};

export default InboxTransitionReviewByCustomerLateCancel;
